import { SinglePageBaseModel } from "./single-page-base.model";

export class UserProfileModel extends SinglePageBaseModel {

  protected icon = 'user';

  protected header = 'Mi Perfil';

}
